<template>
  <svg :width="width" :height="height">
    <g :transform="graphTransform">
      <orthogonal-axes
         ref="axes"
         :xLabelRotate="xLabelRotate"
         :xLabelWidth="xLabelWidth"
         :width="graphWidth"
         :height="graphHeight"
         :xTitle="xTitle"
         :yTitle="yTitle"
         :xFormatter="xFormatter"
         :yFormatter="yFormatter"
         :x="x"
         :y="y" >
      </orthogonal-axes>
      <g class="axes" >
        <line :x1="0" :y1="y(0)" :x2="graphWidth" :y2="y(0)" class="axis x" />
      </g>
      <g 
        v-for="(bar, i) in data"
        :key="bar.x + '@' + bar.z"
        :transform="`translate(${x(bar.x)},0)`" >
        <popover
          :content="popoverFormatter ? popoverFormatter(bar) : yFormatter(bar.y)"
          :delay="100"
          :hideDelay="100" >
          <rect
            :class="['bar', 'hoverable']"
            :x="z(bar.z)"
            :y="bar.y >= 0 ? y(bar.y) : y(0)"
            :width="Math.max(z.bandwidth(), 0)"
            :height="Math.max(bar.y >= 0 ? (y(0) - y(bar.y)) : (y(bar.y) - y(0)), 0)"
            :style="{fill: zColor(bar.z)}" />
        </popover>
      </g>
    </g>
  </svg>
</template>

<script>
import Bar from './Bar.vue'
import * as d3 from 'd3'
import * as d3Chromatic from 'd3-scale-chromatic'

export default {
  extends: Bar,
  props: {
    groupPadding: {
      type: Number,
      default: 0.05
    },
    color: {
      default: () => {
        return d3.scaleSequential(d3Chromatic.interpolateSpectral)
      }
    }
  },
  data () {
    return {
      keyColors: []
    }
  },
  computed: {
    z () {
      return d3.scaleBand().padding(this.groupPadding)
    },
    zColor () {
      return d3.scaleOrdinal()
    }
  },
  methods: {
    update (val) {
      if (val) {
        this.x.domain(val.map(d => d).sort((a, b) => {
          if (!this.sortByValue) {
            return 0
          }
          if (a.y === b.y) {
            return 0
          }
          if (this.sortReverse) {
            return a.y > b.y ? 1 : -1
          }
          return a.y > b.y ? -1 : 1
        }).map(d => {
          return d.x
        }))
        this.z.domain(val.map(d => d.z)).range([0, this.x.bandwidth()])
        this.minY = Math.min(0, this.min === null ? d3.min(val, d => d.y) : this.min)
        this.y.domain([this.minY, this.max === null ? d3.max(val, d => d.y) : this.max])
        if (typeof this.color.domain !== 'undefined') {
          this.color.domain([0, 100])
          this.zColor.domain(this.z.domain())
          this.zColor.range(this.z.domain().map((_, i) => {
            if (this.z.domain().length < 2) {
              return this.color(50)
            }
            return this.color(100 * i / (this.z.domain().length - 1))
          }))
          this.keyColors.splice(0, this.keyColors.length, ...this.zColor.domain().map(val => {
            return {
              label: val,
              color: this.zColor(val)
            }
          }))
        }
      } else {
        this.minY = 0
      }
      this.$nextTick(() => {
        this.$refs.axes.draw()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/GroupedBar.vue